export const checkTextHasTriggerWords = (text, triggerWordsArray) => {
    if (!text || text === "" || !Array.isArray(triggerWordsArray) || triggerWordsArray.length === 0) return false;

    //example of triggerWordsArray = ["hey bo", "hey paul", "hey bull", "hey bo", "hey, po", "hey bro", "hey bough", "hey beau", "hey bow"];

    //we need to create an array of arrays, where each array is a set of words split by space
    //then we check if all words in each array are present in the text, in order
    //this allows us to detect phrases like "hey bo" even if there is punctuation or extra spaces

    const splittedTriggerWords = triggerWordsArray.map(phrase =>
        phrase
            .toLowerCase()
            .split(" ")
            .filter(word => word !== "")
    );

    const simplifiedText = text
        .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "") // -> remove punctuation
        .trim()
        .toLowerCase();

    const splittedText = simplifiedText.split(" ").filter(word => word !== "");

    //return triggerWordsArray.every(phrase => simplifiedText.includes(phrase));
    return splittedTriggerWords.some(phraseArray => {
        let currentIndex = 0;
        return phraseArray.every(word => {
            const foundIndex = splittedText.indexOf(word, currentIndex);
            if (foundIndex === -1) return false;
            currentIndex = foundIndex + 1;
            return true;
        });
    });
};

export const speechContainsWakeWord = resultText => {
    const triggerPhrases = [
        "hey bo",
        "hey paul",
        "hey bull",
        "hey pull",
        "hey po",
        "hey bro",
        "hey bough",
        "hey beau",
        "hey bow",
        "hey bill",
        "hey ball",
        "hey bowl",
        "hey pill",
        "hey bob",
        "hey bold",
        "hey thought",
        "hey bought",
        "hey bot",
        "hey though"
    ];

    if (checkTextHasTriggerWords(resultText, triggerPhrases)) return true;
    else return false;
};

export const speechContainsStopListening = resultText => {
    if (checkTextHasTriggerWords(resultText, ["stop listening"])) return true;
    else return false;
};

export const speechContainsPurchaseIntent = resultText => {
    const purchasePhrases = ["buy", "purchase", "shopping"];

    if (checkTextHasTriggerWords(resultText, purchasePhrases)) return true;
    else return false;
};

export const speechContainsOpenBotagIntent = resultText => {
    const openBotagPhrases = [
        "open botag",
        "show botag",
        "view botag",
        "see botag",
        "show me the botag",
        "open the botag",
        "show me the product",
        "open the product",
        "show the product",
        "show me the products",
        "open the products",
        "show the products"
    ];
    if (checkTextHasTriggerWords(resultText, openBotagPhrases)) return true;
    else return false;
};

export const speechContainsTakePhoto = resultText => {
    if (
        checkTextHasTriggerWords(resultText, [
            "take a photo",
            "capture a photo",
            "snap a photo",
            " take photo",
            "capture photo",
            "camera",
            "take a picture",
            "take picture",
            "snap picture",
            "capture a picture"
        ])
    )
        return true;
    else return false;
};

export const speechContainsTakePhotoFromRaybanMeta = resultText => {
    if (checkTextHasTriggerWords(resultText, ["rayban meta", "ray ban meta", "rayban", "ray ban"])) return true;
    else return false;
};

export const speechContainsFetchPhotoFromGallery = resultText => {
    const fetchPhotoPhrases = [
        "fetch photo from gallery",
        "get photo from gallery",
        "retrieve photo from gallery",
        "bring photo from gallery",
        "photo gallery",
        "from gallery"
    ];

    if (checkTextHasTriggerWords(resultText, fetchPhotoPhrases)) return true;
    else return false;
};
